import { CARE_FOCUS_OPTIONS } from "../constants/childProfileOptions";

const PRIMARY_CARE_FOCUS_CODES = new Set(CARE_FOCUS_OPTIONS.map((item) => item.code));

const PRIORITY_PRIMARY_CARE_FOCUS_CODES = [
  "HOSPICE",
  "PALLIATIVE_CARE",
  "DEMENTIA",
  "CHRONIC",
  "ASD",
  "GENERAL_CARE",
];

const getOptionKey = (item = {}) => String(item?.code || item?.label || item || "").toUpperCase();

export const isPrimaryCareFocusOption = (item = {}) => (
  PRIMARY_CARE_FOCUS_CODES.has(String(item?.code || "").toUpperCase())
);

export const normalizeCareFocusSelection = (items = []) => {
  const normalizedItems = Array.isArray(items) ? items.filter(Boolean) : [items].filter(Boolean);
  const priorityItem = PRIORITY_PRIMARY_CARE_FOCUS_CODES
    .map((code) => normalizedItems.find((item) => getOptionKey(item) === code))
    .find(Boolean);

  if (priorityItem) {
    return [
      priorityItem,
      ...normalizedItems.filter((item) => item !== priorityItem),
    ];
  }

  const primaryItem = normalizedItems.find(isPrimaryCareFocusOption);
  if (!primaryItem) return normalizedItems;

  return [
    primaryItem,
    ...normalizedItems.filter((item) => item !== primaryItem),
  ];
};

export const splitCareFocusSelection = (items = []) => {
  const normalized = normalizeCareFocusSelection(items);
  const primaryFocus = normalized.find(isPrimaryCareFocusOption) || null;
  const rest = normalized.filter((item) => item !== primaryFocus);

  return {
    primaryFocus,
    additionalSupports: rest.filter((item) => !isPrimaryCareFocusOption(item)),
    conditionContext: rest.filter(isPrimaryCareFocusOption),
  };
};

export const composeCareFocusSelection = (primaryFocus, additionalSupports = []) => {
  const supports = (Array.isArray(additionalSupports) ? additionalSupports : [additionalSupports])
    .filter(Boolean)
    .filter((item) => !isPrimaryCareFocusOption(item));
  const seen = new Set();

  return [primaryFocus, ...supports]
    .filter(Boolean)
    .filter((item) => {
      const key = getOptionKey(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
